module.exports = "<main [ngClass]=\"{'darkMode': darkMode}\">\n    <board [darkMode]=\"darkMode\"></board>\n    <console [darkMode]=\"darkMode\"></console>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/interactive-board/client/src/app/app.template.html
// module id = ../../../../../src/app/app.template.html
// module chunks = main